/**
 * Plus Icon.
 * 
 * @returns SVG element.
 */

export const PlusIcon = () => (
	<svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M21.2874 11.838L21.2976 10.0613L11.8243 10.1159L11.8243 10.1087L11.8051 10.1088L11.8598 0.623469L10.0831 0.633708L10.0273 10.1059L0.556327 10.1605L0.546088 11.9372L10.0302 11.8837L10.0301 11.9029L10.0373 11.9029L9.98394 21.375L11.7606 21.3648L11.8152 11.8938L21.2874 11.838Z" fill="currentColor"/>
	</svg>
);

/**
 * Minus Icon.
 * 
 * @returns SVG element.
 */

export const MinusIcon = () => (
	<svg viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M21.2871 8.93682L21.2973 7.06097L0.553672 7.0616L0.545735 8.93682L10.0299 8.93682L11.8149 8.93682L21.2871 8.93682Z" fill="currentColor"/>
	</svg>
);

/**
 * Refresh Icon.
 * 
 * @returns SVG element.
 */

export const ResetIcon = () => (
	<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M9 0.924805L9.40039 0.93457C11.3963 1.03357 13.2903 1.87034 14.71 3.29004L14.9863 3.58008C16.3275 5.06133 17.0752 6.99221 17.0752 9C17.0752 11.0078 16.3275 12.9387 14.9863 14.4199L14.71 14.71C13.1956 16.2243 11.1417 17.0752 9 17.0752C6.99221 17.0752 5.06133 16.3275 3.58008 14.9863L3.29004 14.71C1.77571 13.1956 0.924805 11.1417 0.924805 9V8.9248H2.4082V9C2.40339 10.6046 2.98612 12.1556 4.0459 13.3604L4.24902 13.5811C5.28882 14.6597 6.66855 15.3526 8.16113 15.54C9.75328 15.7399 11.3638 15.3507 12.6885 14.4453L12.9326 14.2705C14.1295 13.3694 14.9851 12.0836 15.3525 10.625L15.4189 10.332C15.6982 8.96207 15.5336 7.53828 14.9482 6.26855L14.8154 5.99902C14.1238 4.66312 12.9966 3.608 11.625 3.00488L11.3477 2.88965C9.94466 2.34767 8.40118 2.30453 6.97461 2.76172L6.69043 2.86035C5.22634 3.40454 4.0071 4.45263 3.24609 5.81348H5.51953V7.29688H0.924805V2.70312H2.4082V4.36035C3.12258 3.33288 4.06915 2.48631 5.17188 1.88965L5.39453 1.77441C6.47555 1.23249 7.6657 0.942864 8.87598 0.926758L8.875 0.924805H9Z" fill="currentColor" stroke="currentColor" stroke-width="0.15"/>
	</svg>
);

/**
 * Close Icon.
 * 
 * @returns SVG element.
 */

export const CloseIcon = () => (
	<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M16.0016 1.26356L14.7525 0L8.09239 6.73729L8.08733 6.73218L8.07385 6.74582L1.40533 0L0.15625 1.26356L6.81465 8.00085L0.15625 14.7364L1.40533 16L8.07385 9.25589L8.08733 9.26953L8.09239 9.26442L14.7525 16L16.0016 14.7364L9.34316 8.00085L16.0016 1.26356Z" fill="currentColor"/>
	</svg>
);

/**
 * TCC Eagle svg.
 * 
 * @returns SVG element.
 */
export const TccEagleIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 60 56">
		<path d="M42.39.2175c1.5486.0486 3.786 1.755 3.989 3.2481 0 0-15.8901-.523-19.3013.2863-7.2328 1.7178-7.3796 12.9743-11.0988 17.8143-1.1235 1.4627-3.0553 2.7164-3.666 2.7944-.5909.0781-.315-.5656-.315-.5656 2.0683-5.8143 4.1756-13.1695 6.3228-17.286C20.1521 2.998 24.7215.1108 29.1928.0718c0 0 10.0714.0477 13.1972.1457ZM58.899 7.271c.7053 1.4389.8671 3.0848.6541 4.663-.0172.1277-.2402.1209-.3036 0-1.2033-2.293-2.4739-4.3887-5.2372-4.9796-2.7633-.5908-5.9066-.3654-9.1764-.4044 0 0 1.7023-2.083 2.3043-2.8091 1.5248 0 9.5963-.4939 11.7588 3.5309" fill="currentColor" />
		<path d="M58.4583 12.7953c.1841.4076-.1977.3233-.5308.3276-6.7079.0981-12.8112 2.0162-15.1397 8.4951-1.5824 4.4011-3.3704 10.3707-4.9658 15.0729-1.1227 3.2776-3.8246 6.7035-6.9816 8.1159-.321.144-.6697-.1561-.5908-.3123.0989-.1562 1.3395-1.6388 2.1862-3.668.8468-2.0483 5.121-15.5032 7.0747-21.0251 2.1793-6.1605 8.6724-9.8724 15.8011-9.2313 2.0042.1803 2.9627 1.8176 3.1467 2.2252ZM35.1296 20.8582s-1.4575 2.8091-1.7924 3.7261c-2.3042 5.9896-3.6723 11.1316-5.8386 17.1602-1.1651 3.1891-4.6588 6.7721-7.1695 7.6674-.3895.1388-.6697-.0972-.5708-.4485 2.1272-3.1024 3.1318-6.9066 4.3924-10.3204 1.4774-4.5651 2.8247-9.3956 4.795-13.7073 1.3195-2.8482 4.0965-4.487 6.1847-4.0775M25.631 22.8011s-1.5364 2.9852-1.8912 3.9604c-2.4422 6.3799-3.6047 11.1792-5.9089 17.5974-1.677 3.6914-4.3282 7.2015-7.4063 8.0968-.3965.1154-.6897-.0971-.5908-.4875 2.2062-3.2976 3.3088-7.336 4.6284-10.9841 1.5755-4.8774 2.718-9.3253 4.8062-13.9303 1.3786-3.0043 4.2155-4.7212 6.3618-4.2527M14.9749 28.0979l-2.2472 1.5098.7907 2.6062-2.1388-1.6714-2.2288 1.5639.9348-2.5529-2.1754-1.6356 2.7145.09.8807-2.5704.7549 2.6063 2.7146.0541ZM12.4096 35.8645l-2.2463 1.5098.7907 2.6062-2.1389-1.6714-2.2288 1.5639.934-2.5529-2.1746-1.6356 2.7146.09.8807-2.5704.7548 2.6062 2.7138.0542ZM9.8275 43.5203 7.5812 45.03l.7907 2.6063-2.1388-1.6714-2.2288 1.5639.9349-2.5529-2.1755-1.6356 2.7145.09.8807-2.5704.755 2.6062 2.7136.0542ZM7.2885 51.4168l-2.2463 1.5097.7907 2.6063-2.1388-1.6714-2.2289 1.5639.934-2.5529-2.1746-1.6356 2.7146.09.8807-2.5705.7548 2.6063 2.7138.0542ZM42.2381 7.33h-7.0627c-.6151 0-2.0761.2924-2.9653 1.4636-.4095.5397-.6247.897-.7609 1.756 0 0 0 .0971.2533 0 .2343-.0972.5553-.3609 1.3074-.4095h5.6903c.6273 0 1.7794-.1163 2.7354-1.0532.9561-.917 1.3473-1.756.8025-1.756" fill="currentColor" />
	</svg>
);

/**
 * Caret Icon.
 */
export const CaretIcon = () => (
	<svg viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M7 8L0.25 0L7 2.66667L13.75 8.07577e-07L7 8Z" fill="currentColor"/>
	</svg>
);